import { AlertCircle, Edit } from 'lucide-react';
import { Button } from '@/components/ui/button';

const getPaymentFailureDetail = (payment) => {
  const details = [
    payment.payment_response_message,
    payment.payment_failure_reason ? `Código PagBank: ${payment.payment_failure_reason}` : null,
    payment.payment_response_code ? `Resposta: ${payment.payment_response_code}` : null,
    payment.pagseguro_charge_id ? `Charge: ${payment.pagseguro_charge_id}` : null,
  ].filter(Boolean);

  return details.join(' | ');
};

export default function OrdersTab({ orders, onEditOrder }) {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-heading font-bold uppercase text-primary">Gerenciar Pedidos</h2>
      </div>

      <div className="bg-card border border-border rounded-lg overflow-x-auto">
        <table className="w-full">
          <thead className="bg-secondary">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-widest text-primary">Cliente</th>
              <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-widest text-primary">Email</th>
              <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-widest text-primary">Itens</th>
              <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-widest text-primary">Valor</th>
              <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-widest text-primary">Pagamento</th>
              <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-widest text-primary">Entrega</th>
              <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-widest text-primary">Status Envio</th>
              <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-widest text-primary">Ações</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {orders.map((order) => {
              const paymentFailureDetail = getPaymentFailureDetail(order);
              return (
                <tr key={order.id} data-testid={`order-${order.id}`}>
                  <td className="px-4 py-3 font-bold text-foreground">{order.customer_name}</td>
                  <td className="px-4 py-3 text-sm text-foreground">{order.customer_email}</td>
                  <td className="px-4 py-3 text-sm text-foreground">{order.items.length} item(s)</td>
                  <td className="px-4 py-3 font-bold text-accent">R$ {order.total_amount.toFixed(2)}</td>
                  <td className="px-4 py-3">
                    <div className="space-y-1">
                      <div className="flex items-center gap-2">
                        <span
                          title={paymentFailureDetail || undefined}
                          className={`text-xs uppercase tracking-widest font-bold px-3 py-1 rounded-sm ${
                            order.payment_status === 'paid'
                              ? 'bg-green-100 text-green-800'
                              : order.payment_status === 'pending'
                              ? 'bg-yellow-100 text-yellow-800'
                              : 'bg-red-100 text-red-800'
                          }`}
                        >
                          {order.payment_status === 'paid' ? 'Pago' : order.payment_status === 'pending' ? 'Pendente' : 'Falhou'}
                        </span>
                        {order.payment_status === 'failed' && paymentFailureDetail && (
                          <Button
                            size="sm"
                            variant="outline"
                            onClick={() => alert(paymentFailureDetail)}
                            className="h-7 w-7 p-0 rounded-sm text-red-700"
                            title="Ver motivo da falha"
                          >
                            <AlertCircle className="w-4 h-4" />
                          </Button>
                        )}
                      </div>
                      {order.payment_status === 'failed' && paymentFailureDetail && (
                        <p className="max-w-xs truncate text-xs text-red-700" title={paymentFailureDetail}>
                          {paymentFailureDetail}
                        </p>
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-foreground">
                    {order.delivery_method === 'delivery' ? 'Entrega' : 'Retirar Evento'}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`text-xs uppercase tracking-widest font-bold px-3 py-1 rounded-sm ${
                      order.shipping_status === 'delivered' || order.shipping_status === 'pickup_ready'
                        ? 'bg-green-100 text-green-800'
                        : order.shipping_status === 'sent'
                        ? 'bg-blue-100 text-blue-800'
                        : 'bg-gray-100 text-gray-800'
                    }`}>
                      {order.shipping_status === 'pending' ? 'Pendente' :
                       order.shipping_status === 'sent' ? 'Enviado' :
                       order.shipping_status === 'delivered' ? 'Entregue' : 'Pronto p/ Retirar'}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <Button
                      data-testid={`edit-order-${order.id}`}
                      size="sm"
                      variant="outline"
                      onClick={() => onEditOrder(order)}
                      className="rounded-sm"
                    >
                      <Edit className="w-4 h-4 mr-1" />
                      Editar
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {orders.length === 0 && (
        <div className="text-center py-12 bg-card border border-border rounded-lg">
          <p className="text-foreground/50">Nenhum pedido encontrado.</p>
        </div>
      )}
    </div>
  );
}
